//
// SelectionMode.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var SelectionMode = {
    NONE:0,
    SINGLE:1,
    MULTIPLE:2
};
export default SelectionMode;
